import { render, staticRenderFns } from "./AppointmentsTabs.vue?vue&type=template&id=02cd6522"
import script from "./AppointmentsTabs.vue?vue&type=script&lang=js"
export * from "./AppointmentsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports